import type { FC } from 'react';

import RatingSummary from '@eneco/components/RatingSummary/RatingSummary';
import { CustomerRatingRendering } from '@sitecore/types/CustomerRating';

const CustomerRating: FC<CustomerRatingRendering> = data => (
  <div>
    <RatingSummary {...data} />
  </div>
);
export { CustomerRating };
export default CustomerRating;
